import logoTunefund from "assets/images/logo/logo-tunefund.svg"
import iconTunefund from "assets/images/logo/logo-tunefund-icon.svg"
import { KLogo } from "kahuna-base-react-components"

const TunefundLogo = ({
  width,
  height,
  textVisible,
  paddingHorizontal
}: {
  width: number
  height?: number
  textVisible?: boolean
  paddingHorizontal?: number
}) => {
  const getLogoImg = () => {
    const url = window.location.origin
    if (url.includes("tunefund.io")) {
      return <img src={textVisible ? logoTunefund : iconTunefund} alt="icon logo" style={{ width, height }} />
    }

    return (
      <div
        style={{
          marginTop: textVisible ? 24 : 0,
          paddingRight: paddingHorizontal ? paddingHorizontal : 0,
          paddingLeft: paddingHorizontal ? paddingHorizontal : 0
        }}
      >
        <KLogo
          width={textVisible ? width / 1.65 : width * 2.2}
          height={textVisible ? height || width / 1.6 : height || width * 2.2}
          primaryTextVisible={textVisible}
          logoColor="white"
          primaryTextHeight={width / 3}
          primaryTextWidth={width}
        />
      </div>
    )
  }
  return getLogoImg()
}

export default TunefundLogo
